import { render } from "./a-container.vue?vue&type=template&id=b556224c&scoped=true"
const script = {}

import "./a-container.vue?vue&type=style&index=0&id=b556224c&lang=scss&scoped=true"

import exportComponent from "/www/publicHouse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b556224c"]])

export default __exports__